import script from "./ToastMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastMessage.vue?vue&type=script&setup=true&lang=js"

import "./ToastMessage.vue?vue&type=style&index=0&id=aee4f39c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aee4f39c"]])

export default __exports__